import { useParams } from "react-router-dom";
import ContactClient from "../../components/contact/ContactClient";
import { normalizeLocale } from "../../utils/locales";

export default function ContactPage() {
  const { locale } = useParams();
  const loc = normalizeLocale(locale);
  return <ContactClient locale={loc} />;
}
